import React from 'react';
import { Icon } from '@vectord/components';

import styles from './BatchDetails.module.scss';

function BatchDetails({ superBatch }) {
  const { name: superBatchName } = superBatch;

  return (
    <div className={styles.root}>
      <div className={styles.circle}>
        <Icon
          name="discussion"
          className="primary h1 text-c"
        />
      </div>
      <div className="column m-l-xs">
        <div className="bold h3 dark">Batch Name:</div>
        <span>
          <span className="m-r-xs">{superBatchName}</span>
        </span>
      </div>
    </div>
  );
}

export default BatchDetails;
